import analytics, { useLoadAnalytics } from '~/services/analytics';

export { useLoadAnalytics };
export default analytics;
